var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClinical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.413,
    height: 29.49,
    viewBox: "0 0 30.413 29.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_57385",
    "data-name": "Group 57385",
    transform: "translate(-927.378 -445.751)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_54053",
    "data-name": "Group 54053",
    transform: "translate(861.06 301.354)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_54040",
    "data-name": "Group 54040",
    transform: "translate(66.317 144.398)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "stethoscope-solid",
    d: "M38.359,1.3A1.846,1.846,0,0,1,37.2,3.63l-1.509.5v6.964a5.53,5.53,0,1,0,11.059,0V4.131l-1.5-.5a1.843,1.843,0,1,1,1.169-3.5l1.5.5a3.681,3.681,0,0,1,2.517,3.5v6.964A9.22,9.22,0,0,1,43.1,20.121a6.452,6.452,0,0,0,12.862-.732V15.317a4.608,4.608,0,1,1,3.686,0v4.072a10.137,10.137,0,0,1-20.247.743A9.221,9.221,0,0,1,32,11.095V4.131a3.684,3.684,0,0,1,2.523-3.5l1.5-.5A1.846,1.846,0,0,1,38.359,1.3ZM57.805,12.938a1.843,1.843,0,1,0-1.843-1.843A1.843,1.843,0,0,0,57.805,12.938Z",
    transform: "translate(-32 -0.038)",
    fill: "#1470d3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinical);
export default __webpack_public_path__ + "static/media/clinical.6b6565605eaa96e141055daa8bea7e09.svg";
export { ForwardRef as ReactComponent };